export const listCross = (ctx: CanvasRenderingContext2D, color: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color

  // 左上＿右下
  ctx.beginPath()
  ctx.moveTo(259, 540) // 左上
  ctx.quadraticCurveTo(265, 572, 277, 582) //
  ctx.quadraticCurveTo(282, 588, 297, 592) // 右下
  ctx.quadraticCurveTo(307, 589, 297, 581) // 右上
  ctx.quadraticCurveTo(282, 577, 272, 558) //
  ctx.quadraticCurveTo(264, 541, 259, 540) //
  ctx.fill()
  ctx.moveTo(259, 545) // 左上
  ctx.quadraticCurveTo(266, 552, 272, 569) //
  ctx.quadraticCurveTo(278, 580, 300, 587) //
  ctx.stroke()
  ctx.closePath()

  // 右上＿左下
  ctx.beginPath()
  ctx.moveTo(279, 529) // 右上
  ctx.quadraticCurveTo(250, 551, 271, 582) // 下
  ctx.quadraticCurveTo(272, 584, 271, 581) //
  ctx.quadraticCurveTo(267, 557, 283, 538) //
  ctx.quadraticCurveTo(287, 527, 279, 529) // 右上
  ctx.fill()
  ctx.moveTo(283, 532) // 右上
  ctx.quadraticCurveTo(262, 557, 270, 582) // 下
  ctx.stroke()
}

export const listStraight = (ctx: CanvasRenderingContext2D, color: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  // 左上右下方向の革紐
  ctx.beginPath()
  ctx.moveTo(285 + x, 523 + y) // 左上
  ctx.quadraticCurveTo(283 + x, 528 + y, 288 + x, 528 + y) // 左下
  ctx.quadraticCurveTo(292 + x, 523 + y, 306 + x, 517 + y) // 右下
  ctx.quadraticCurveTo(308 + x, 510 + y, 301 + x, 508 + y) // 右上
  ctx.quadraticCurveTo(281 + x, 517 + y, 285 + x, 523 + y) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 右上左下方向の革紐
  ctx.beginPath()
  ctx.moveTo(296 + x, 545 + y) // 左上
  ctx.quadraticCurveTo(300 + x, 554 + y, 300 + x, 554 + y) // 左下
  ctx.quadraticCurveTo(310 + x, 562 + y, 327 + x, 560 + y) // 右下
  ctx.quadraticCurveTo(328 + x, 552 + y, 322 + x, 548 + y) // 右上
  ctx.quadraticCurveTo(307 + x, 550 + y, 296 + x, 545 + y) // 左上
  ctx.fill()
  ctx.moveTo(296 + x, 545 + y) // 左上
  ctx.quadraticCurveTo(307 + x, 553 + y, 325 + x, 550 + y) // 左下
  ctx.stroke()
  ctx.closePath()
}

export const listStraightThumb = (ctx: CanvasRenderingContext2D, color: string, x: number, y: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  // 左上右下方向の革紐
  ctx.beginPath()
  ctx.moveTo(467 + x, 505 + y) // 左上
  ctx.quadraticCurveTo(465 + x, 509 + y, 470 + x, 515 + y) // 左下
  ctx.quadraticCurveTo(484 + x, 518 + y, 497 + x, 511 + y) // 右下
  ctx.quadraticCurveTo(501 + x, 506 + y, 500 + x, 499 + y) // 右上
  ctx.quadraticCurveTo(481 + x, 507 + y, 467 + x, 505 + y) // 左上
  ctx.moveTo(467 + x, 505 + y) // 左上
  ctx.quadraticCurveTo(481 + x, 510 + y, 500 + x, 501 + y) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
